import React from "react";

function GoogleMapIFrame(props) {
  const { latitudeData, longitudeData } = props;
  
  return (
    <>
      <h2 className="head6">Restaurant Location</h2>
      <iframe
        title="dsfdsf"
        src={`https://www.google.com/maps?q=${latitudeData},${longitudeData}&hl=es;z%3D14&amp&output=embed`}
        width="100%"
        height="200"
      />
    </>
  );
}

export default GoogleMapIFrame;
